import { useState } from "react";
import moment from "moment/moment";
import { uiNotification } from "../../../../../../services/UINotificationService";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { useDebouncedState } from "../../../../../../utilities/hooks/useDebouncedState";
import { ORDER_TYPES } from "../../../../../../consts/api";
import { useShopifyProductSalesReportQuery } from "../../../../../../api/shopifyReports/useShopifyProductSalesReportQuery";
import { usePrevious } from "../../../../../../utilities/hooks/usePrevious";

var prepareReqPeriod = (periodState) => {
  return {
    from: periodState.from || null,
    to: periodState.to || null,
  };
};

var prepareReqOrder = (orderState) => {
  if (Object.values(orderState).every(Boolean)) {
    return {
      by: orderState.by,
      direction: orderState.direction,
    };
  }
  return null;
};

export var useReport = () => {
  var { tBi: t } = useAppTranslation.BusinessInsights();
  var { 0: search, 1: debouncedSearch, 2: setSearch } = useDebouncedState("");

  var { 0: order, 1: setOrder } = useState({
    by: "",
    direction: "",
  });

  var updateOrder = (orderFieldKey) => {
    setOrder({
      by: orderFieldKey,
      direction:
        order.direction === ORDER_TYPES.desc
          ? ORDER_TYPES.asc
          : ORDER_TYPES.desc,
    });
  };

  var { 0: period, 1: setPeriod } = useState({
    from: moment().startOf("month").toDate(),
    to: moment().endOf("month").toDate(),
  });

  var { data, isLoading } = useShopifyProductSalesReportQuery(
    {
      period: prepareReqPeriod(period),
      search: debouncedSearch,
      order: prepareReqOrder(order),
    },
    {
      onError: () => {
        uiNotification.error(t("shopifyProductSalesReport.error.fetch"));
      },
    },
  );

  var prevReports = usePrevious(data?.reports);

  return {
    reports: {
      value: isLoading ? prevReports || [] : data?.reports || [],
      isLoading,
    },
    period: {
      value: period,
      update: setPeriod,
    },
    search: {
      value: search,
      update: setSearch,
    },
    order: {
      value: order,
      update: updateOrder,
    },
  };
};
